import React, { useState, useEffect } from "react";
import { X, ShieldOff, CalendarClock } from "lucide-react";

const toLocalInputValue = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const BlockModal = ({ show, onClose, onConfirm, defaultMessage }) => {
  const [message, setMessage] = useState(defaultMessage || "");
  const [aviso, setAviso] = useState(defaultMessage || "");
  const [agendar, setAgendar] = useState(false);
  const [quando, setQuando] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() + 3);
    return toLocalInputValue(d);
  });

  useEffect(() => {
    if (!show) return;
    const base = defaultMessage || "";
    setMessage(base);
    setAviso(base);
    setAgendar(false);
    const d = new Date();
    d.setDate(d.getDate() + 3);
    setQuando(toLocalInputValue(d));
  }, [show, defaultMessage]);

  if (!show) return null;

  const handleConfirm = () => {
    if (agendar) {
      const dt = new Date(quando);
      if (Number.isNaN(dt.getTime()) || dt <= new Date()) {
        alert("Informe uma data/hora futura para o bloqueio programado.");
        return;
      }
      onConfirm({
        mensagemBloqueio: message,
        mensagemAvisoBloqueio: aviso || message,
        bloqueioProgramadoEm: dt.toISOString(),
        agendado: true,
      });
      return;
    }

    onConfirm({ mensagemBloqueio: message, agendado: false });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden="true" />

      <div className="relative w-full max-w-lg rounded-2xl zen-card p-6 shadow-xl dark:bg-slate-950/80 dark:border-white/10">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            <h5 className="text-xl font-bold text-gray-900 dark:text-white">
              {agendar ? "Agendar bloqueio" : "Bloquear licença"}
            </h5>
          </div>
          <button onClick={onClose} className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-white/10" type="button">
            <X size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={agendar} onChange={(e) => setAgendar(e.target.checked)} />
            Agendar bloqueio futuro
          </label>

          {agendar ? (
            <>
              <input type="datetime-local" value={quando} onChange={(e) => setQuando(e.target.value)} className="w-full px-3 py-2 rounded-xl border" />
              <textarea value={aviso} onChange={(e) => setAviso(e.target.value)} placeholder="Mensagem de aviso" className="w-full h-24 p-3 rounded-xl border" />
            </>
          ) : null}

          <textarea value={message} onChange={(e) => setMessage(e.target.value)} className="w-full h-28 p-3 rounded-xl border" />
        </div>

        <div className="flex justify-end mt-5 gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-xl bg-gray-200">Cancelar</button>
          <button type="button" onClick={handleConfirm} className="px-4 py-2 rounded-xl bg-red-600 text-white inline-flex gap-2 items-center">
            {agendar ? <CalendarClock size={18} /> : <ShieldOff size={18} />}
            {agendar ? "Agendar" : "Bloquear"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockModal;
